export const Popular = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 16 16" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.91912 6H8.00003V4H13.3334V9.33333H11.3334V7.41419L8.00001 10.7475L6.66669 9.41422L4.08219 11.9988L2.66797 10.5845L6.66667 6.58578L8.00001 7.91912L9.91912 6Z"
        fill="#261B36"
      />
    </svg>
  );
};
